import React from 'react'
import "./Footers.css"
import { Col, Container, Row } from 'react-bootstrap'

const Footer = () => {
  return (
    <>
        
    <section id="footers">
        <Container>
            <Row className='footer-main'>
                <Col xs={6} lg={3} sm={6} md={3}>
                    <div class="footer_inner">
                        <img src="imeges/Organic.png" alt=""/>
                       <p> Calista Wise 7292 Disctum Av.</p>
                       <p>New York.USA</p>
                      <p>(02)-800-5145-88</p>
                      <p>info@gmail.com</p>
                      <p>www.website.com</p>
                    </div>
                </Col>
                <Col xs={6} lg={3} sm={6} md={3}>
                    <div class="footer-main-inner">
                        <h3>Customer Service</h3>
                        <p>Contact us</p>
                        <p>Track your order</p>
                        <p>Return policy</p>
                        <p>Delivery Information</p>
                        <p>Help & FAQ</p>
                        <p>Warranty & Repair</p>
                    </div>
                </Col>
                <Col xs={6} lg={2} sm={6} md={2}>
                    <div class="footer-main-text">
                        <h3>Categories</h3>
                        <p>Fruitls & Vegetables</p>
                        <p>Dairy Products</p>
                        <p>Package Foods</p>
                        <p>Beverage</p>
                        <p>Health & Wellness</p>
                    </div>
                </Col>
                <Col xs={6} lg={4} sm={6} md={4}>
                    <div class="footer-main-main">
                        <h3>Newsletter</h3>
                        <p>Signup and get a voucher of worth $250.00</p>
                        <form class="d-flex" role="search">
                            <input class="form-control me-2" type="search" placeholder="Your email address" aria-label="Search"/>
                            <button class="btn btn-outline-success" type="submit">Search</button>
                          </form>
                    </div>
                </Col>
            </Row>
        </Container>
    </section>
    </>
  )
}

export default Footer